import type { MessagingChannelsCopy } from './types';

export const IT: MessagingChannelsCopy = {
  title: 'Messaggistica',
  description:
    'Parla con IMAI dalle app di chat che usi già. Collegati una volta, poi scrivi a IMAI da lì.',
  privacy:
    'I messaggi dai tuoi account collegati vengono eseguiti a tuo nome in questo spazio di lavoro e usano i tuoi crediti.',
  loading: 'Caricamento dei canali di messaggistica',
  unavailable: 'Non ancora disponibile',
  unavailableNote: '{channel} non è ancora configurato per IMAI.',
  connectedBadge: 'Collegato',
  cancel: 'Annulla',

  phoneTitle: 'Numero di telefono',
  phoneNote: 'Collega WhatsApp o iMessage con il tuo numero di telefono.',
  phoneUnavailableNote:
    'I messaggi di testo con IMAI non sono ancora configurati.',
  addNumber: 'Aggiungi numero',
  countryLabel: 'Prefisso internazionale',
  countrySearch: 'Cerca paese o prefisso…',
  countryEmpty: 'Nessun paese trovato.',
  numberLabel: 'Numero di telefono',
  numberPlaceholder: 'Numero di telefono',
  numberHint:
    'Il tuo paese non è in elenco? Scrivi il numero completo iniziando con +.',
  continueActivation: 'Continua',
  editNumber: 'Cambia numero',
  activateQr: 'Scansiona e invia per collegarti.',
  activateTitle: 'Invia un messaggio su WhatsApp',
  activateHint: 'Tocca il pulsante e invia il messaggio già compilato per te.',
  activateSentFrom: 'Invialo dal {number}.',
  activateButton: 'Apri {channel}',
  activateManual: 'Oppure invia {message} al {number} su WhatsApp.',
  activateWaiting: 'In attesa del tuo messaggio. Scade tra {time}.',
  startAgain: 'Ricomincia',
  verifiedBadge: 'Verificato',
  verifiedOn: 'Verificato il {date}',
  change: 'Cambia',
  changeAria: 'Cambia il numero {number}',
  remove: 'Rimuovi',
  removeAria: 'Rimuovi il numero {number}',
  messageImai: 'Scrivi a IMAI',
  messageImaiAria: 'Scrivi a IMAI su {channel}',
  removeTitle: 'Rimuovere {number}?',
  removeDescription:
    'IMAI smetterà di rispondere a questo numero su iMessage e WhatsApp. Puoi aggiungerlo di nuovo quando vuoi.',
  removeError: 'Impossibile rimuovere il numero. Riprova.',

  errorInvalidNumber: 'Inserisci un numero valido, con il prefisso.',
  errorNumberTaken: 'Questo numero è già usato da un altro account IMAI.',
  errorRateLimited: 'Troppi tentativi. Aspetta un po’, poi riprova.',
  errorChannelUnavailable:
    'Questa opzione non è disponibile ora. Scegli l’altra.',
  errorSendFailed: 'Impossibile avviare la verifica. Riprova.',
  errorActivationExpired: 'Questa attivazione è scaduta. Ricomincia.',

  noteSlack: 'Scrivi a IMAI dal tuo spazio di lavoro Slack.',
  noteTeams: 'Scrivi a IMAI da Microsoft Teams.',
  noteTelegram: 'Chatta con il bot di IMAI su Telegram.',
  connect: 'Collega',
  connectAria: 'Collega {channel}',
  connectError: 'Impossibile avviare il collegamento a {channel}. Riprova.',
  connectedOn: 'Collegato il {date}',
  accountFallback: 'Il tuo account {channel}',
  installSlack: 'Aggiungi IMAI al tuo spazio di lavoro',
  installTeams: 'Aggiungi IMAI a Teams',
  openTelegram: 'Apri in Telegram',
  disconnect: 'Scollega',
  disconnectAria: 'Scollega {account} da {channel}',
  disconnectError: 'Impossibile scollegare {channel}. Riprova.',
  disconnectTitle: 'Scollegare {channel}?',
  disconnectDescription:
    'I messaggi da {account} non arriveranno più a IMAI. Puoi ricollegarlo quando vuoi.',

  toastConnected: '{channel} collegato',
  toastConnectedGeneric: 'Account collegato',
  toastErrorExpired: 'L’accesso ha richiesto troppo tempo. Riprova.',
  toastErrorInvalidState: 'Questo link di accesso non è più valido. Riprova.',
  toastErrorAccountTaken:
    'Questo account è già collegato a un altro utente IMAI.',
  toastErrorNotMember: 'Non sei più membro di questo spazio di lavoro.',
  toastErrorProvider: 'L’accesso non è stato completato. Riprova.',
  toastErrorGeneric: 'Impossibile collegare l’account. Riprova.',
};
